<template>
  <div>
    <vs-row>
      <vs-col vs-offset="2" vs-type="flex" vs-justify="center" vs-align="center" vs-w="8">
        <div class="vx-col sm:w-1/1 w-full mb-2">
        <vx-card :title="(subjects && classes) ? `${subjects[data.quiz.subj_id].name}` : 'Subject'">
          <div>
            <h5>
            <span v-for="(v) in data.quiz.class" :key="v.class_id">
              <span class="mb-2">{{ classes[v.class_id].short_name }} . </span>
            </span>
            </h5>
          </div>
          <vs-row vs-w="12">
            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6">
              {{ data.quiz.type.toUpperCase() }}
            </vs-col>
            <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
              {{ (data.quiz.duration) ? `${data.quiz.duration} mins` : '' }}
            </vs-col>
          </vs-row>

          <br>

          <div class="text-center">
            <vs-divider></vs-divider>
            <br>
            <i>{{ data.quiz.description }}</i>
            <br><br>
            <vs-divider></vs-divider>
          </div>

          <br> <br>


          <div class="vx-row">
            <div class="vx-col sm:w-1/1 w-full mb-2" v-for="(q, index) in data.quiz.questions" :key="index">
              <vx-card class="question">
                <div>
                  <p class="md-5">
                    <b>{{ q.body }}</b>
                  </p>
                  <div v-if="q.type === 'multipleopt'">
                    <ul class="optionlist2 ml-5">
                      <li v-for="(v, indexv) in q.typeOption" :key="indexv">
                        {{ v }}
                      </li>
                    </ul>
                  </div>
                  <div v-else-if="q.type === 'multiplesel'">
                    
                  </div>
                  <div v-else-if="q.type === 'fillspace'">
                    <br>
                    <vs-input xv-model="group.instructions" class="w-full" placeholder="Your Answer"  />
                  </div>
                  <div v-else>
                    <br>
                    <vs-textarea xv-model="" label="Your Answer" rows="3" />
                  </div>
                </div>

                <vs-row vs-w="12" class="mt-1">
                  <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="12">
                    {{ data.quiz.activity[q.id] }} Marks
                  </vs-col>
                </vs-row>
              </vx-card>
              <br>
            </div>
          </div>

          <div class="vx-col w-full">
            <!-- <vs-button class="mr-3 mb-2" @click="saveQuiz">Edit</vs-button> -->

            <vs-dropdown>
              <a class="flex items-center" href="#">
                More Options
                <i class="material-icons"> expand_more </i>
              </a>

              <vs-dropdown-menu>
                <vs-dropdown-item @click="openDelConfirm()">
                  Delete Quiz
                </vs-dropdown-item>

                <!-- <vs-dropdown-item>
                  Option 2
                </vs-dropdown-item>

                <vs-dropdown-item divider>
                  Option 3
                </vs-dropdown-item> -->
              </vs-dropdown-menu>

            </vs-dropdown>
          </div>

        </vx-card>
      </div>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import vSelect from 'vue-select'

import { quillEditor } from 'vue-quill-editor'
import Prism from 'vue-prism-component'

export default {
  data () {
    return {
      data: {
        quiz: {}
      }
    }
  },
  components: {
    quillEditor,
    Prism,
    vSelect
  },
  watch: {
    
  },

  computed: {
    subjects () {
      return this.$store.state.academics.subjects
    },
    classes () {
      return this.$store.state.academics.classes
    }
  },

  created () {
    this.$http.get(`/lms/st/task/quiz/content/${this.$route.params.id}`).then((response) => {
      if (response && response.data && response.data.data) {
        this.data.quiz = response.data.data
      }
    }).catch((error) => { 
      console.log(error)
    })
  },

  methods: {
    openDelConfirm () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm',
        text: 'Do you really want to delete this Quiz.',
        accept: this.deleteQuiz
      })
    },

    deleteQuiz () {
      this.$http.delete(`/lms/st/task/quiz/content/${this.$route.params.id}`).then((response) => {
        if (response && response.data && response.data.data) {
          this.$vs.notify({
            color: 'success',
            title: 'Deleted Quiz',
            text: 'The selected Quiz was successfully deleted'
          })
        }
      }).catch((error) => { 
        console.log(error)
      })
    }
  }
}
</script>


<style scoped>
.optionlist {
  list-style: outside;
  list-style-type: decimal;
}

.optionlist2 {
  list-style: outside;
  list-style-type: upper-alpha;
}

.optionlist li {
  margin: 10px;
}

input.oinputx {
  width: 100%;
  padding-left: 5px;
  font-size: 15px;
  background: transparent;
  border: none;
  border-bottom: 1px solid #ddd;
}
</style>